import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Footer.module.scss';
import clsx from 'clsx';
import Link from '../Link/Link';
import { useNavigate } from 'react-router';
const Footer = ({ show }) => {
  const navigate = useNavigate();
  return (
    <>
      <footer className={clsx(styles.footer, !show && styles.footerFull)}>
        <div className={clsx(styles.footerLeft)}>© 2025, GammiPass</div>
        <div className={clsx(styles.footerRight)}>
          <Link
            className={styles.footerLink}
            noLine
            onClick={() => {
              navigate('/privacy-policy');
            }}>
            Политика конфиденциальности
          </Link>
          <Link
            className={styles.footerLink}
            noLine
            onClick={() => {
              navigate('/payments');
            }}>
            Условия оплаты
          </Link>
          <Link
            className={styles.footerLink}
            noLine
            onClick={() => {
              navigate('/contacts');
            }}>
            Контакты
          </Link>
        </div>
      </footer>
    </>
  );
};

export default Footer;
